import { EventObject } from "../api/eventObject";
export class ActionQueueFullError extends Error {
}
export class Action {
    constructor() {
        this._completeEvent = new EventObject();
    }
    start() {
    }
    stop() {
    }
    get completeEvent() {
        return this._completeEvent;
    }
}
export class ActionQueue {
    constructor() {
        this._maximumActionCount = 1024;
        this._currentAction = null;
        this._actions = new Array();
        this._startedEvent = new EventObject();
        this._emptiedEvent = new EventObject();
    }
    add(action) {
        if (this._actions.length >= this._maximumActionCount) {
            throw new ActionQueueFullError("Exceeded maximum action count: " + this._maximumActionCount);
        }
        if (this._currentAction === null) {
            this._startedEvent.raise();
            this._doAction(action); //Do it now
        }
        else {
            this._actions.push(action); //Queue for later
        }
    }
    get isEmpty() {
        return this._currentAction === null && this._actions.length === 0;
    }
    stop() {
        //Deal with currentAction
        if (this._currentAction !== null) {
            this._currentAction.completeEvent.remove(this, this._onCurrentActionComplete);
            this._currentAction.stop();
            this._currentAction = null;
        }
        //Deal with waiting actions.
        this._actions.length = 0;
        this._emptiedEvent.raise();
    }
    get startedEvent() {
        return this._startedEvent;
    }
    get emptiedEvent() {
        return this._emptiedEvent;
    }
    _doAction(action) {
        this._currentAction = action;
        this._currentAction.completeEvent.add(this, this._onCurrentActionComplete);
        this._currentAction.start();
    }
    _onCurrentActionComplete() {
        if (this._currentAction != null) {
            this._currentAction.completeEvent.remove(this, this._onCurrentActionComplete);
            this._currentAction = null;
        }
        this._tryDoNextAction();
    }
    _tryDoNextAction() {
        const action = this._actions.shift();
        if (action) {
            this._doAction(action);
        }
        else {
            this._emptiedEvent.raise(); //we're empty!
        }
    }
}
